import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Seo, { breadcrumbs } from "../components/Seo";
import { SectionHeader } from "../components/UI";
import VehicleCard from "../components/VehicleCard";
import LeadForm from "../components/LeadForm";
import { savedStore } from "../lib/storage";

export default function SavedVehicles() {
  const [items, setItems] = useState([]);
  useEffect(() => {
    const sync = () => setItems(savedStore.list());
    sync();
    window.addEventListener("ssc-storage", sync);
    return () => window.removeEventListener("ssc-storage", sync);
  }, []);

  const summary = items.map((v) => `${v.year} ${v.make} ${v.model} ${v.trim || ""} (Stock ${v.stock_number})`).join("\n");

  return (
    <main id="main-content">
      <Seo
        title="Saved Vehicles | Scott Sells Chevys"
        description="View your saved vehicles and send your list to Scott for help comparing options."
        canonicalPath="/saved-vehicles"
        jsonLd={[breadcrumbs([{ name: "Home", path: "/" }, { name: "Saved Vehicles", path: "/saved-vehicles" }])]}
      />
      <section className="ssc-hero">
        <div className="ssc-container py-10 md:py-16">
          <h1 className="ssc-display text-3xl md:text-5xl font-extrabold">Saved Vehicles</h1>
          <p className="mt-3 text-[var(--ssc-silver)]">Your shortlist lives here — no login required.</p>
        </div>
      </section>

      <section className="ssc-section">
        <div className="ssc-container">
          {items.length === 0 ? (
            <div className="ssc-card text-center" data-testid="saved-empty">
              <h2 className="text-xl font-extrabold text-[var(--ssc-navy)]">No saved vehicles yet.</h2>
              <p className="text-[var(--ssc-ink-2)] mt-2">Tap the Save button on any vehicle card to add it here.</p>
              <div className="mt-4 flex flex-wrap gap-2 justify-center">
                <Link to="/new-vehicles" className="ssc-btn ssc-btn-navy">Shop New</Link>
                <Link to="/used-vehicles" className="ssc-btn ssc-btn-outline">Shop Used</Link>
              </div>
            </div>
          ) : (
            <>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 mb-10">
                {items.map((v) => <VehicleCard key={v.slug} vehicle={v} />)}
              </div>
              <SectionHeader title="Send my saved list to Scott" subtitle="Scott will help you compare and pick a direction." />
              <LeadForm
                leadType="saved_vehicles"
                leadSource="Saved Vehicles Page"
                testIdPrefix="saved-lead"
                fields={[
                  { name: "name", label: "Name", required: true, autoComplete: "name" },
                  { name: "phone", label: "Phone", inputMode: "tel", autoComplete: "tel" },
                  { name: "email", label: "Email", type: "email", autoComplete: "email" },
                  { name: "preferred_contact", label: "Preferred Contact", type: "select", options: ["Text", "Call", "Email"] },
                  { name: "message", label: "Message", type: "textarea", full: true, placeholder: "Anything specific you want to compare?" },
                ]}
                hidden={{ saved_list: summary, cta_clicked: "Saved Send to Scott" }}
                submitLabel="Send My Saved List to Scott"
              />
            </>
          )}
        </div>
      </section>
    </main>
  );
}
